<template>
	<div class="w-full surface-0 relative ">
		<TitleScreen :title="content[lang_].title" :subtitle="content[lang_].subtitle" />
		<TransferScreen :currency_receive_first="'inr'" />
		<MainHowItWorks />
	</div>
	<div class="center px-3">
        <div class="flex flex-column p-0 justify-content-center align-items-center text-center">
            <h3 class="flex font-normal text-700 p-0
                text-2xl xl:text-4xl lg:text-4xl md:text-3xl sm:text-3xl">
                Денежные переводы в Индию за 15 минут
            </h3>
        </div>
    </div>
	<MainReviewsSlider />
	<MainStat />
	<div class="center px-3">
        <div class="flex flex-column p-0 justify-content-center align-items-center text-center">
            <h3 class="flex font-normal text-700 p-0
                text-2xl xl:text-4xl lg:text-4xl md:text-3xl sm:text-3xl">
               Сервис для переводов денег из РФ в Индию и обратно 
            </h3>
        </div>
    </div>
	<TableCompare />
	<BannerFirstTransfer v-if="!isAuth"/>
	<div class="center px-3">
        <div class="flex flex-column p-0 justify-content-center align-items-center text-center">
            <h3 class="flex font-normal text-700 p-0
                text-2xl xl:text-4xl lg:text-4xl md:text-3xl sm:text-3xl">
               	Перевод денег в Индию
            </h3>
        </div>
    </div>
	<MainFeatures />
	<MainFaq  />
	<div class="center px-3">
        <div class="flex flex-column p-0 justify-content-center align-items-center text-center">
            <h3 class="flex font-normal text-700 p-0
                text-2xl xl:text-4xl lg:text-4xl md:text-3xl sm:text-3xl">
               	Отправка денег из России в Индию и обратно
            </h3>
        </div>
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import TitleScreen 			from '@/components/widgets/main/TitleScreen.vue' 
import TransferScreen 		from '@/components/widgets/main/TransferScreen.vue' 
import MainHowItWorks 		from '@/components/widgets/main/MainHowItWorks.vue'
import MainReviewsSlider 	from '@/components/widgets/main/MainReviewsSlider.vue' 
import BannerFirstTransfer 	from '@/components/widgets/main/BannerFirstTransfer.vue' 
import BannerPartner 		from '@/components/widgets/main/BannerPartner.vue' 
import MainStat 			from '@/components/widgets/main/MainStat.vue' 
import TableCompare 		from '@/components/widgets/main/TableCompare.vue' 
import MainFeatures 		from '@/components/widgets/main/MainFeatures.vue' 
import MainFaq 				from '@/components/widgets/main/MainFaq.vue'

export default {
	data() {
		return {
			content: {
				en: {
					title: "Send money from Russia to India in 15 minutes",
					subtitle: "from 3000 rubles through the automated PayWave service",
				} ,
				ru: {
					title: "Переводите деньги из России в Индию за 15 минут",
					subtitle: "от 3000 рублей через автоматизированный сервис PayWave",
				},
			}, 
		}
	},
	components: {
		TitleScreen,
		TransferScreen,
		MainHowItWorks,
		MainReviewsSlider,
		BannerFirstTransfer,
		BannerPartner,
		MainStat,
		TableCompare,
		MainFeatures,
		MainFaq,
	},
	watch: {},
	computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },	
		isAuth: function () { return this.$store.getters.isAuthenticated },
	},
	methods: {},
	async beforeCreate() {},
	async mounted() {}
}
</script>